import script from "./ExportPublication.vue?vue&type=script&setup=true&lang=js"
export * from "./ExportPublication.vue?vue&type=script&setup=true&lang=js"

import "./ExportPublication.vue?vue&type=style&index=0&id=7f437160&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f437160"]])

export default __exports__